var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('vuescroll',{attrs:{"ops":{
      bar: {
        background: '#bacfcec0',
        keepShow: true,
      },
    }}},[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.tableHeaders,"items":_vm.tableList,"loading":_vm.isLoading,"options":_vm.options,"server-items-length":_vm.totalItems,"footer-props":{
        'items-per-page-options': [15, 30, 50, 100],
      }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.assignment_agent",fn:function(ref){
      var item = ref.item;
return [_c('span',[_vm._v("\n          "+_vm._s(item.assignment_agent == 1 ? item.registers__not_dialed_agent_count : item.registers__not_dialed_count)+"\n        ")])]}},{key:"item.action",fn:function(ref){
      var item = ref.item;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var hover = ref.hover;
return [_c('v-btn',{attrs:{"text":"","icon":"","color":hover ? 'accent' : 'blue-grey'},on:{"click":function($event){$event.stopPropagation();return _vm.goToRegister(item)}}},[_c('v-icon',[_vm._v("\n              mdi-archive-edit-outline\n            ")])],1)]}}],null,true)})]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }